<template>
  <!-- <div>{{text}}</div> -->
  <div>
    <my-header
      :page_name="$t('navigation.headerTitles.configTree')"
      show_usermenu
    ></my-header>
    <my-form
      v-if="formActionType !== '' && formOpen"
      :formActionType="formActionType"
      :type="childElemType"
      :fromReference="showFullForm"
      @close="
        formOpen = false;
        showFullForm = false;
      "
      @editOk="editOk"
      @addOk="addOk"
    ></my-form>
    <el-dialog :visible.sync="deleteDbDialog" width="40%" v-if="!!curNode">
      <span slot="title" class="delete-dialog-title">
        <div>{{ $t("configTree.selectActionWithBase") }}</div>
        <div class="delete-dialog-element-name">{{ curNode.text }}</div>
      </span>
      <div class="base-radio-options">
        <el-radio v-model="deleteDbRadio" label="delete">{{
          $t("configTree.untieBaseAndDelete")
        }}</el-radio>
        <el-radio v-model="deleteDbRadio" label="unlink">{{
          $t("configTree.untieBase")
        }}</el-radio>
        <el-radio v-model="deleteDbRadio" label="erase">{{
          $t("configTree.untieBaseFromAllAppsAndDelete")
        }}</el-radio>
        <el-radio v-model="deleteDbRadio" label="unlock">{{
          $t("configTree.untieBaseFromAllApps")
        }}</el-radio>
      </div>
      <div class="buttons-bottom">
        <div></div>
        <div>
          <el-button
            class="button-cancel"
            type="plain"
            @click="deleteDbDialog = false"
            >{{ $t("configTree.cancel") }}</el-button
          >
          <el-button
            class="button-confirm"
            type="success"
            @click="okClickDbDialog"
            >ОК</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="deleteSectionDialog" width="40%" v-if="!!curNode">
      <span slot="title" class="delete-dialog-title">
        <div>{{ $t("configTree.selectActionWithApp") }}</div>
        <div class="delete-dialog-element-name">{{ curNode.text }}</div>
      </span>
      <div v-if="getBasesInSection.length > 0">
        {{ $t("configTree.linkedBasesNumber") }} {{ getBasesInSection.length }}
        <br />
        <b>{{ $t("configTree.selectBaseToUnselect") }}</b>
        <el-select v-model="basesToUnlink" multiple :key="selectKey" filterable>
          <el-option
            v-for="(base, index) in getBasesInSection"
            :key="index"
            :label="baseLabel(base)"
            :value="base.idBase"
          ></el-option>
        </el-select>
        <el-button @click="unlinkAllBases" type="text" size="mini">{{
          $t("configTree.selectAllBases")
        }}</el-button>
        <el-button @click="basesToUnlink = []" type="text" size="mini">{{
          $t("configTree.unselectAllBases")
        }}</el-button>
        <br />
        <el-radio v-model="deleteSectionRadio" label="unlink">{{
          $t("configTree.unlinkSelectedBases")
        }}</el-radio>
      </div>
      <div v-else>{{ $t("configTree.noLinkedBases") }}</div>
      <div class="base-radio-options" style="margin-top: 5px">
        <el-radio v-model="deleteSectionRadio" label="hard">{{
          $t("configTree.deleteApp")
        }}</el-radio>
      </div>
      <div class="buttons-bottom">
        <div></div>
        <div>
          <el-button
            class="button-cancel"
            type="plain"
            @click="deleteSectionDialog = false"
            >{{ $t("configTree.cancel") }}</el-button
          >
          <el-button
            class="button-confirm"
            type="success"
            @click="okClickSectionDelete"
            >ОК</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="deleteSectionConfirmationDialog"
      width="40%"
      v-if="!!curNode"
    >
      <span slot="title" class="delete-dialog-title">
        <div>{{ $t("sections.selectAction") }}</div>
        <div class="delete-dialog-element-name">{{ curNode.text }}</div>
      </span>
      <div style="word-break: normal">
        <div>{{ $t("sections.thisActionDeleteAppWholly") }}.</div>
        <br />
        <div>
          {{
            $t("sections.basesAndPackets", {
              bases: getBasesInSection.length,
              packets: sectionPackets.length,
            })
          }}.
        </div>
        <br />
        {{ $t("sections.continue") }}?
      </div>
      <div class="buttons-bottom">
        <div></div>
        <div>
          <el-button
            class="button-cancel"
            type="plain"
            @click="deleteSectionConfirmationDialog = false"
            >{{ $t("sections.cancel") }}</el-button
          >
          <el-button
            class="button-confirm"
            type="success"
            @click="deleteSectionHard"
            >ОК</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="infoDialogOpen"
      v-if="infoDialogOpen"
      :title="$t('referenceGrid.bindsInfo')"
      center
      width="60%"
    >
      <div v-if="curNode.type === 'db'">
        <b>{{ $t("referenceGrid.appsToWhichBaseLinked") + ":" }}</b>
        <div
          v-for="(sect, index) in getSectionsInBaseArray"
          :key="index"
          style="padding-left: 5px"
        >
          &#8226;
          <span>{{ sect.name }};</span>
        </div>
        <br />
        <div v-if="getSectionsInBaseArray.length > 0">
          {{ $t("referenceGrid.toUnlinkAppsGoToDeleteMenu") }}
        </div>
        <div v-else>{{ $t("referenceGrid.currentBaseNotLinkedToApp") }}</div>
      </div>
      <div v-else-if="curNode.type === 'app'">
        <b>{{ $t("referenceGrid.basesLinkedToApp") + ":" }}</b>
        <div
          v-for="(base, index) in getBasesInSection"
          :key="index"
          style="padding-left: 5px"
        >
          &#8226;
          <span>{{ baseLabel(base) }}</span>
        </div>
        <br />
        <div v-if="getBasesInSection.length === 0">
          {{ $t("referenceGrid.noLinkedBasesToCurrentApp") }}
        </div>
        <br />
        <b>{{ $t("referenceGrid.packetsWithSection") + ":" }}</b>
        <div
          v-for="packet in sectionPackets"
          :key="packet.name"
          style="padding-left: 5px"
        >
          &#8226;
          <span>{{ packet.name }}</span>
        </div>
        <br />
        <div v-if="sectionPackets.length === 0">
          {{ $t("referenceGrid.noPacketsWithSection") }}
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="copySectionDialog" v-if="!!curNode">
      <span slot="title" class="delete-dialog-title">
        <div>{{ $t("configTree.enterData") }}</div>
        <div class="delete-dialog-element-name">{{ curNode.text }}</div>
      </span>
      <div>
        {{ $t("configTree.attentionAppCopy") }}
      </div>
      <el-form :model="copySectionData" :rules="copyRules" ref="copyForm">
        <el-form-item :label="$t('configTree.name')" prop="name">
          <el-input v-model="copySectionData.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('configTree.alias')" prop="alias">
          <el-input v-model="copySectionData.alias"></el-input>
        </el-form-item>
        <el-form-item :label="$t('configTree.path')" prop="path">
          <el-input v-model="copySectionData.path"></el-input>
        </el-form-item>
      </el-form>
      <div class="buttons-bottom">
        <div></div>
        <div>
          <el-button
            class="button-cancel"
            type="plain"
            @click="copySectionDialog = false"
            >{{ $t("configTree.cancel") }}</el-button
          >
          <el-button
            class="button-confirm"
            type="success"
            @click="okClickSectionCopy"
            >ОК</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showManager"
      v-if="showManager"
      width="95%"
      custom-class="more-info-dialog"
    >
      <div class="manager-block more-info__inner">{{ managerFile }}</div>
      <div class="bottom-buttons">
        <div></div>
        <el-button class="el-icon-download left" @click="saveToFile">
          {{ $t("history.saveInFile") }}
        </el-button>
      </div>
    </el-dialog>
    <div class="buttons-grid">
      <!-- <el-button class="el-icon-">Скачать</el-button> -->
      <div class="buttons-group">
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTree.add')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="addClick"
              type="primary"
              class="el-icon-plus"
              :disabled="addDisabled"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTree.fastCreate')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="addBaseClick"
              type="primary"
              class="el-icon-magic-stick"
              v-if="addBaseShow"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTree.copy')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="copyClick"
              v-if="copyShow"
              type="primary"
              class="el-icon-copy-document"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTree.edit')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="editClick"
              type="primary"
              class="el-icon-edit"
              :disabled="editDisabled"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('referenceGrid.info')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="infoClick"
              v-if="
                !!curNode && (curNode.type === 'db' || curNode.type === 'app')
              "
              class="el-icon-info"
              type="primary"
              :disabled="editDisabled"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTree.delete')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="deleteClick"
              type="danger"
              class="el-icon-delete"
              :disabled="deleteDisabled"
            ></el-button>
          </span>
        </el-tooltip>
      </div>
      <div class="buttons-group">
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTree.refreshData')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="refresh"
              class="el-icon-refresh-right"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTree.refreshServerSynchrDate')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="refreshDates"
              class="el-icon-refresh"
            ></el-button>
          </span>
        </el-tooltip>
      </div>
      <div class="buttons-group">
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTree.createServer')"
          placement="bottom-start"
        >
          <span>
            <el-button @click="addServerClick" class="el-icon-plus left">
              <i class="el-icon-files"></i>
            </el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTree.exportManagerCfg')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="exportClick"
              :type="exportType"
              class="el-icon-upload2 left"
              >{{ $t("configTree.export") }}
              <span v-if="serverName">&mdash; {{ serverName }}</span></el-button
            >
          </span>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTree.importManagerCfg')"
          placement="bottom-start"
        >
          <span>
            <el-button @click="getManager" class="el-icon-download">
              <span v-if="serverName"> {{ serverName }}</span>
            </el-button>
          </span>
        </el-tooltip>
      </div>
      <div style="margin-left: 2em" v-if="getUser && +getUser.roleid <= 1">
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('navigation.userMenu.backup')"
          placement="bottom-start"
        >
          <span>
            <el-button @click="backupBase" class="el-icon-upload left">{{
              $t("navigation.userMenu.backup")
            }}</el-button>
          </span>
        </el-tooltip>
      </div>
      <!-- <el-button @click="commitBtnClick">Экспорт</el-button> -->
    </div>
    <tree></tree>
  </div>
</template>


<script>
import Form from "../../components/config/form_elements/Form";
import Tree from "../../components/config/Tree";
import Header from "../../components/reusable/header/Header";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    myHeader: Header,
    myForm: Form,
    Tree,
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("configTree.enterNewAppName")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    const validatePath = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("configTree.enterNewPath")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    return {
      formOpen: false,
      deleteDbDialog: false,
      deleteSectionDialog: false,
      copySectionDialog: false,
      deleteSectionConfirmationDialog: false,
      infoDialogOpen: false,
      deleteDbRadio: "",
      deleteSectionRadio: "",
      formActionType: "",
      childElemType: "",
      showFullForm: false,
      addDisabled: true,
      editDisabled: true,
      deleteDisabled: true,
      addBaseShow: false,
      copyShow: false,
      exportShow: false,
      copySectionData: {
        name: null,
        alias: null,
        path: null,
      },
      copyRules: {
        name: {
          required: true,
          validator: validateName,
          trigger: "blur",
        },
        alias: {
          required: false,
        },
        path: {
          required: true,
          validator: validatePath,
          trigger: "blur",
        },
      },
      basesToUnlink: [],
      selectKey: 0,
      exportType: "default",
      showManager: false,
      managerFile: null,
    };
  },
  methods: {
    addServerClick() {
      this.childElemType = "server";
      this.addClick();
    },
    refresh() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getConfigTree")
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    refreshDates() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getServers")
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    // readyForm() {
    //   this.formOpen = true;
    //   this.$store.commit("setLoading", false);
    // },
    addClick() {
      this.formActionType = "add";
      this.formOpen = true;
      // this.readyForm();
    },
    addBaseClick() {
      this.$prompt(this.$t("configTree.enterNameForBaseFastCreate"), {
        confirmButtonText: "OK",
        cancelButtonText: this.$t("configTree.back"),
        inputPattern: /^\w+\d*$/,
        inputErrorMessage: this.$t("configTree.wrongFormat"),
      })
        .then(({ value }) => {
          value = value.trim();
          // console.log(value);
          let node = {
            baseName: value,
          };
          let mode = "runScript";
          this.$store
            .dispatch("insBaseTable", { node, mode })
            .then(() => {
              return this.$store.dispatch("getConfigTree");
            })
            .then(() => {
              this.$store.commit("setLoading", false);
              this.$message(this.$t("configTree.checkAccess"));
            })
            .catch(() => {
              this.$store.commit("setLoading", false);
            });
        })
        .catch(() => {});
    },
    editClick() {
      this.$store.commit("setLoading", true);
      this.formActionType = "edit";
      // console.log(this.formActionType);
      // console.log(this.childElemType);
      let getFn = "";
      //console.log(this.curNode.id);
      if (this.curNode.type === "server") {
        getFn = "getServerInfo";
      } else if (this.curNode.type === "app") {
        getFn = "getSectionInfo";
      } else if (this.curNode.type === "db") {
        this.showFullForm = true;
        getFn = "getBaseInfo";
      } else if (this.curNode.type === "app param") {
        getFn = "getSectionParamInfo";
      } else this.$store.commit("setLoading", false);
      this.$store
        .dispatch("getInfo", {
          id: this.curNode.id,
          getFn,
        })
        .then(() => {
          // this.readyForm();
          this.formOpen = true;
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    copyClick() {
      this.copySectionDialog = true;
      this.copySectionData = {
        name: null,
        alias: null,
        path: null,
      };
    },
    sendCopyData({ name, alias, path, origID }) {
      this.$store.commit("setLoading", true);
      // //console.log(this.copySectionData);
      // //console.log(this.currentId);
      this.copySectionDialog = false;
      this.copySectionData.name = null; // удалить все заполненные значения
      this.copySectionData.alias = null; // удалить все заполненные значения
      this.copySectionData.path = null; // удалить все заполненные значения
      this.$store
        .dispatch("copySection", {
          name,
          alias,
          path,
          origID,
        })
        .then(() => {
          return this.$store.dispatch("getConfigTree");
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    okClickSectionCopy() {
      if (!!this.copySectionData.name)
        this.copySectionData.name = this.copySectionData.name.trim();
      if (!!this.copySectionData.path)
        this.copySectionData.path = this.copySectionData.path.trim();
      if (!!this.copySectionData.alias)
        this.copySectionData.alias = this.copySectionData.alias.trim();

      this.$refs.copyForm.validate((valid) => {
        if (valid) {
          if (this.copySectionData.alias === null) {
            this.$confirm(
              this.$t("configTree.desirableEnterAlias"),
              this.$t("configTree.attention"),
              {
                confirmButtonText: this.$t("configTree.continue"),
                cancelButtonText: this.$t("configTree.comeback"),
                type: "info",
              }
            )
              .then(() => {
                this.sendCopyData({
                  name: this.copySectionData.name,
                  alias: "null",
                  path: this.copySectionData.path,
                  origID: this.curNode.id,
                });
              })
              .catch(() => {
                this.copySectionDialog = true;
                // this.copySectionData.name = name; // вернуть все заполненные значения
                // this.copySectionData.path = path;
              });
          } else {
            this.sendCopyData({
              name: this.copySectionData.name,
              alias: this.copySectionData.alias,
              path: this.copySectionData.path,
              origID: this.curNode.id,
            });
          }
        }
      });
    },
    deleteClick() {
      if (this.curNode.type === "db") {
        // this.$store.commit("setParentId", this.curNode.lId.slice(0, 5));
        this.deleteDbRadio = "";
        this.deleteDbDialog = true;
      } else if (this.curNode.type === "app") {
        this.$store.dispatch("getBasesSection", this.curNode.id).then(() => {
          this.deleteSectionDialog = true;
          this.basesToUnlink = [];
          this.deleteSectionRadio = "";
        });
      } else if (this.curNode.type === "server") {
        this.$confirm(
          this.$t("configTree.thisActionDeleteServer") +
            this.curNode.text.substring(
              this.curNode.text.indexOf(">") + 1,
              this.curNode.text.lastIndexOf("<")
            ) +
            ". " +
            this.$t("configTree.continue") +
            "?",
          this.$t("configTree.attention"),
          {
            confirmButtonText: "OK",
            cancelButtonText: this.$t("configTree.cancellation"),
            type: "warning",
          }
        )
          .then(() => {
            this.$store.commit("setLoading", true);

            return this.$store.dispatch("delServerTable", this.curNode.id);
          })
          .then(() => {
            return this.$store.dispatch("getConfigTree");
          })
          .then(() => {
            this.$store.commit("setLoading", false);
            this.$store.commit("setCurNode", null);
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      } else if (this.curNode.type === "app param") {
        this.$confirm(
          this.$t("configTree.paramDeleteAction") +
            this.curNode.text +
            ". " +
            this.$t("configTree.continue") +
            "?",
          this.$t("configTree.attention"),
          {
            confirmButtonText: "OK",
            cancelButtonText: this.$t("configTree.cancellation"),
            type: "warning",
          }
        )
          .then(() => {
            this.$store.commit("setLoading", true);

            return this.$store.dispatch("delSectionParam", this.curNode.id);
          })
          .then(() => {
            return this.$store.dispatch("getConfigTree");
          })
          .then(() => {
            this.$store.commit("setLoading", false);
            this.$store.commit("setCurNode", null);
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      } else this.$store.commit("setError", "Can't delete this one yet");
    },
    okClickDbDialog() {
      if (this.deleteDbRadio) {
        // this.$store.commit("setCurNode", this.node);
        this.$store.commit("setLoading", true);
        // console.log(this.curNode);
        this.$store
          .dispatch("delBase", {
            id: this.curNode.id,
            action: this.deleteDbRadio,
          })
          .then(() => {
            return this.$store.dispatch("getConfigTree");
          })
          .then(() => {
            this.$store.commit("setLoading", false);
            this.deleteDbDialog = false;
            this.$store.commit("setCurNode", null);
            this.$message(this.$t("configTree.usersPermissionsDeleted"));
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
            this.deleteDbDialog = false;
          });
      } else {
        this.$store.commit(
          "setError",
          this.$t("configTree.operationNotSelected")
        );
      }
    },
    unlinkAllBases() {
      this.basesToUnlink = [];
      this.getBasesInSection.forEach((base) => {
        // //console.log(base.idBase);
        this.basesToUnlink.push(base.idBase);
        // //console.log(this.basesToUnlink);
      });
      //console.log(this.basesToUnlink);
      this.selectKey++;
    },
    okClickSectionDelete() {
      if (
        this.basesToUnlink &&
        this.basesToUnlink.length > 0 &&
        this.deleteSectionRadio === "unlink"
      ) {
        this.$store.commit("setLoading", true);
        this.$store
          .dispatch("unlinkSectionInReference", {
            idBase: this.basesToUnlink,
            idSection: this.curNode.id,
          })
          .then(() => {
            return this.$store.dispatch("getConfigTree");
          })
          .then(() => {
            this.deleteSectionDialog = false;
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.deleteSectionDialog = false;
            this.$store.commit("setLoading", false);
          });
      } else if (this.deleteSectionRadio === "hard") {
        this.$store
          .dispatch("getBasesSection", this.curNode.id)
          .then(() => {
            return this.$store.dispatch("getSectionPackets", this.curNode.id);
            // console.log(this.getBasesInSection);
          })
          .then(() => {
            this.deleteSectionConfirmationDialog = true;
          })
          .catch((err) => {
            console.error(err);
            this.$store.commit("setLoading", false);
          });
      } else if (
        this.basesToUnlink &&
        this.basesToUnlink.length === 0 &&
        this.deleteSectionRadio === "unlink"
      ) {
        this.$store.commit(
          "setError",
          this.$t("configTree.selectBaseForUnlink")
        );
      } else if (this.deleteSectionRadio === "") {
        this.$store.commit("setError", this.$t("configTree.selectOperation"));
      }
    },
    deleteSectionHard() {
      this.$store
        .dispatch("delSectionHard", this.curNode.id)
        .then(() => {
          return this.$store.dispatch("getConfigTree");
        })
        .then(() => {
          this.deleteSectionDialog = false;
          this.deleteSectionConfirmationDialog = false;
          this.$store.commit("setCurNode", null);
          this.$store.commit("setLoading", false);
        })
        .catch((err) => {
          console.error(err);
          this.deleteSectionConfirmationDialog = false;
          this.deleteSectionDialog = false;
          this.$store.commit("setLoading", false);
        });
    },
    addOk(value) {
      //console.log("value: ", value);
      this.formOpen = false;
      this.$store.commit("setLoading", true);
      let node;
      //если выбрали параметр сервера / приложения
      if (this.childElemType === "app param") {
        node = {
          idParam: value.typeSelected,
          value: value.valueSelected,
        };
        this.$store
          .dispatch("addAppParam", node)
          .then(() => {
            return this.$store.dispatch("getConfigTree");
          })
          .then(() => {
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      } else if (this.childElemType === "db") {
        //добавляем базу только по имени
        let mode;
        if (value.baseSelected) {
          node = value;
          mode = "fullIns";
        } else if (value.hasOwnProperty("baseId")) {
          node = {
            id: value.baseId,
          };
          mode = "linkExisted";
        }
        // else {
        //   node = {
        //     baseName: value.nameSelected,
        //   };
        //   mode = "runScript";
        // }
        //console.log("mode: ", mode);
        //console.log("node: ", node);

        this.$store
          .dispatch("insBaseTable", { node, mode })
          .then(() => {
            return this.$store.dispatch("getConfigTree");
          })
          .then(() => {
            this.$store.commit("setLoading", false);
            this.$message(this.$t("configTree.checkUsersAccessForThisLink"));
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      } else if (this.childElemType === "app") {
        node = value;
        this.$store
          .dispatch("insSectionTable", node)
          .then(() => {
            return this.$store.dispatch("getConfigTree");
          })
          .then(() => {
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      } else if (this.childElemType === "server") {
        this.$store
          .dispatch("createServer", value)
          .then(() => {
            return this.$store.dispatch("getConfigTree");
          })
          .then(() => {
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      } else {
        this.$store.commit("setError", this.$t("configTree.checkAddOK"));
      }
      this.clicked = true;
    },
    editOk(value) {
      this.formOpen = false;
      this.$store.commit("setLoading", true);
      value.unshift(this.curNode.id);
      let updFn = "";
      if (this.childElemType === "db") {
        updFn = "updBaseTable";
        this.showFullForm = false;
      } else if (this.childElemType === "app") updFn = "updSectionTable";
      else if (this.childElemType === "server") updFn = "updServerTable";
      else if (this.childElemType === "app param") {
        updFn = "updSectionOnlyParam";
        value.splice(1, 1);
        //console.log("value ", value);
      }
      this.$store
        .dispatch("updTable", { updArray: value, updFn })
        .then(() => {
          return this.$store.dispatch("getConfigTree");
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    infoClick() {
      if (this.curNode.type === "db") {
        this.$store
          .dispatch("getSectionsInBase", this.curNode.id)
          .then(() => {
            this.infoDialogOpen = true;
            // console.log(this.getSectionsInBaseArray);
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (this.curNode.type === "app") {
        this.$store
          .dispatch("getBasesSection", this.curNode.id)
          .then(() => {
            return this.$store.dispatch("getSectionPackets", this.curNode.id);
            // console.log(this.getBasesInSection);
          })
          .then(() => {
            this.infoDialogOpen = true;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    exportClick() {
      // console.log(this.getParentServerId);
      let serverData = this.getServersTableArray.find(
        (s) => s.serverID === this.getParentServerId
      );
      if (!serverData) {
        this.$store.commit("setError", this.$t("configTree.serverNotSelected"));
        return;
      }
      if (!serverData.tiny) {
        this.$store.commit(
          "setError",
          this.$t("configTree.noTinyAgentOnServer")
        );
        return;
      }
      const curServerData = this.getDates.find(
        (server) => server.idServer === this.getParentServerId
      );
      if (!curServerData) {
        this.$store.commit("setError", "can't find selected server in dates");
        return;
      }
      const baseDateSave = moment(curServerData.dateSave);
      this.$store
        .dispatch("getCurServerManagerDate", this.getParentServerId)
        .then((result) => {
          let fileDate = null;
          if (result.mtime === "no_file") {
            fileDate = null;
          } else fileDate = moment(result.mtime);
          const delta = 5;
          const baseDateAdd = baseDateSave.add(delta, "sec");
          const baseDateSubstract = baseDateSave.subtract(delta, "sec");
          let message = "";
          if (
            baseDateSave.isSame(fileDate) ||
            curServerData.dateSave === null
          ) {
            message = this.$t("configTree.exportManagerQuestion");
          } else if (result.mtime === "no_file") {
            message = this.$t("configTree.createManagerQuestion");
          } else if (
            baseDateAdd.isBefore(fileDate) ||
            baseDateSubstract.isBefore(fileDate)
          ) {
            message = this.$t("configTree.managerFileChanged", {
              fileDate: fileDate.format("YYYY-MM-DD, HH:mm:ss"),
              baseDate: baseDateSave.format("YYYY-MM-DD, HH:mm:ss"),
            });
          } else {
            message = this.$t("configTree.managerFileUnchanged", {
              fileDate: fileDate.format("YYYY-MM-DD, HH:mm:ss"),
              baseDate: baseDateSave.format("YYYY-MM-DD, HH:mm:ss"),
            });
          }
          return this.$confirm(message, "", {
            confirmButtonText: this.$t("configTree.export"),
            cancelButtonText: this.$t("configTree.cancel"),
          });
        })
        .then(() => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("exportConfig", this.getParentServerId);
        })
        .then(() => {
          // console.log("CONFIG EXPORTED");
          return this.$store.dispatch("getConfigTree");
        })
        .then(() => {
          this.checkExportButtonType();
          this.$store.commit("setLoading", false);
        })
        .catch((err) => {
          console.error(err);
          this.$store.commit("setLoading", false);
        });
    },
    getManager() {
      let serverData = this.getServersTableArray.find(
        (s) => s.serverID === this.getParentServerId
      );
      if (!serverData) {
        this.$store.commit("setError", this.$t("configTree.serverNotSelected"));
        return;
      }
      if (!serverData.tiny) {
        this.$store.commit(
          "setError",
          this.$t("configTree.noTinyAgentOnServer")
        );
        return;
      }
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getCurServerManagerFile", this.getParentServerId)
        .then((result) => {
          this.managerFile = result;
          this.$store.commit("setLoading", false);
          this.showManager = true;
        })
        .catch((err) => {
          console.error(err);
          this.$store.commit("setLoading", false);
        });
    },
    saveToFile() {
      let serverName = this.getServersTableArray.find(
        (s) => s.serverID === this.getParentServerId
      ).serverName;
      let file = this.managerFile;
      const fileName = `manager_cfg_${serverName}.txt`;
      let href = "data:application/octet-stream," + encodeURIComponent(file);
      // let href = window.URL.createObjectURL(file);
      //создается выпадающее окно со ссылкой на файл
      var link = document.createElement("a");
      link.setAttribute("href", href);
      link.setAttribute("download", fileName);
      document.body.appendChild(link); // Required for FF

      link.click(); // This will download the data file named "my_data.csv"
    },
    setButtons() {
      if (this.curNode) {
        if (
          this.curNode.type === "app param list" ||
          this.curNode.type === "app list" ||
          this.curNode.type === "db list"
        ) {
          this.copyShow = false;
          this.addDisabled = false;
          this.editDisabled = true;
          this.deleteDisabled = true;
          this.addBaseShow = false;
          if (this.curNode.type === "db list") this.addBaseShow = true;
        } else if (
          this.curNode.type === "server param list" ||
          this.curNode.type === "server param" ||
          (this.curNode.type === "app param" && this.curNode.id === "0")
        ) {
          this.copyShow = false;
          this.addDisabled = true;
          this.editDisabled = true;
          this.deleteDisabled = true;
          this.addBaseShow = false;
        } else if (
          this.curNode.type === "server" ||
          this.curNode.type === "app" ||
          this.curNode.type === "db" ||
          (this.curNode.type === "app param" && this.curNode.id !== "0")
        ) {
          this.addBaseShow = false;
          this.copyShow = false;
          this.addDisabled = true;
          this.editDisabled = false;
          this.deleteDisabled = false;
          if (this.curNode.type === "app") this.copyShow = true;
          // if (this.curNode.type === "server") this.exportShow = true;
        }
        if (
          this.curNode.type === "app param list" ||
          this.curNode.type === "app param"
        ) {
          this.childElemType = "app param";
        } else if (
          this.curNode.type === "server param list" ||
          this.curNode.type === "server param"
        ) {
          this.childElemType = "server param";
        } else if (
          this.curNode.type === "app list" ||
          this.curNode.type === "app"
        ) {
          this.childElemType = "app";
        } else if (this.curNode.type === "server") {
          this.childElemType = "server";
        } else if (
          this.curNode.type === "db" ||
          this.curNode.type === "db list"
        ) {
          this.childElemType = "db";
        }
      } else {
        this.copyShow = false;
        this.addBaseShow = false;
        this.addDisabled = true;
        this.editDisabled = true;
        this.deleteDisabled = true;
      }
    },
    checkExportButtonType() {
      let serverData = this.getServersTableArray.find(
        (s) => s.serverID === this.getParentServerId
      );
      // console.log(serverData);
      if (serverData.serverTypeSrvID === "1") {
        this.exportShow = false;
      } else {
        this.exportShow = true;
      }
      if (this.getNotSyncServers.includes(this.getParentServerId)) {
        this.exportType = "danger";
      } else {
        this.exportType = "default";
      }
    },
    backupBase() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("backupBase")
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    baseLabel(base) {
      let label = base.bname;
      if (base.balias && base.comment) {
        label += " (" + base.balias + ") -- " + base.comment;
      } else if (base.balias) label += " (" + base.balias + ")";
      else if (base.comment) label += " -- " + base.comment;
      return label;
    },
  },
  created() {
    this.$store
      .dispatch("getServerTable")
      .then(() => {
        return this.$store.dispatch("getConfigTree");
      })
      .then(() => {
        return this.$store.dispatch("getServers");
      })
      .then(() => {
        this.$store.commit("setDates");
        this.setButtons();
        this.checkExportButtonType();
        this.$store.commit("setLoading", false);
      })
      .catch(() => {
        this.$store.commit("setLoading", false);
      });
  },
  watch: {
    curNode() {
      this.setButtons();
    },
    getParentServerId() {
      this.checkExportButtonType();
    },
  },
  computed: {
    ...mapGetters([
      "getConfigTree",
      "curNode",
      "getBasesInSection",
      "sectionPackets",
      "getParentServerId",
      "getNotSyncServers",
      "getServersTableArray",
      "getDates",
      "getUser",
      "getSectionsInBaseArray",
    ]),
    serverName() {
      if (!this.getParentServerId) return null;
      let serverData = this.getServersTableArray.find(
        (s) => s.serverID === this.getParentServerId
      );
      if (!serverData) {
        return null;
      }
      return serverData.serverName;
    },
  },
};
</script>

<style scoped>
.buttons-grid {
  position: fixed;
  top: var(--header-height);
}
.buttons-group:not(:first-of-type) {
  margin-left: 2em;
}
.base-radio-options {
  display: flex;
  flex-direction: column;
}
.base-radio-options .el-radio:not(:first-of-type) {
  margin-top: 10px;
}
.delete-dialog-element-name {
  font-weight: 600;
  text-align: center;
}
.manager-block {
  white-space: pre;
  font-family: "Roboto Mono", monospace;
}
.more-info__inner {
  scrollbar-width: auto;
}

.more-info__inner::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
</style>